import { render, staticRenderFns } from "./addChannel.vue?vue&type=template&id=70c36285&scoped=true"
import script from "./addChannel.vue?vue&type=script&lang=js"
export * from "./addChannel.vue?vue&type=script&lang=js"
import style0 from "./addChannel.vue?vue&type=style&index=0&id=70c36285&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c36285",
  null
  
)

export default component.exports